export default "/images/00c47bb33bd82bd7afa3fe72b472a642.avif";